import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { getDataRequest } from 'utils/request';
import ROUTE_PATH from 'routes/config';
import WideButton from 'components/Button/WideButton';
import BlueAlertBox from 'components/BlueAlertBox';
import { ChildTextRow } from '../../style';
import { MainWrapper } from '../style';

const CompletionGuideStep = ({
  hasOtherMallAccount,
  dataProviderSeq,
  selectedMallData,
  completionGuideText1,
  completionGuideText2,
  resetAllData,
  mode,
  accountType,
}) => {
  const navigate = useNavigate();
  const [guideMessage, setGuideMessage] = useState('');
  const { mallName, mallSeq, interlockOpenYn } = selectedMallData;

  // 타 판매몰 추가 연동 버튼 클릭
  const onClickAddMallAccountBtn = () => {
    resetAllData();
    // mode: 등록(register)으로 변경
    if (mode === 'modify' || accountType === 'sub') {
      navigate(ROUTE_PATH.mypage.dataLinkageDataInterlockRequest, {
        replace: true,
      });
    }
  };

  useEffect(() => {
    if (mallSeq && dataProviderSeq) {
      const url = `/v1/au/salesMall/guidance`;
      const params = {
        guidanceExposureLocationCode: 'INTERLOCK',
        mallSeq: mallSeq,
        dataProviderSeq: dataProviderSeq,
      };
      getDataRequest({
        url,
        params,
        setData: data => {
          setGuideMessage(data.guidanceContents);
        },
      });
    }
  }, [mallSeq, dataProviderSeq]);

  return (
    <MainWrapper>
      <div className="contentsWrapper">
        <p className="title">
          {`${mallName} 데이터 연동 요청이 완료됐어요`}
          <br />
          {interlockOpenYn === 'Y' ? (
            <span>{`${completionGuideText1} ${completionGuideText2}`}</span>
          ) : (
            <span>
              {completionGuideText1}
              <br />
              {completionGuideText2}
            </span>
          )}
        </p>
        <div className="completeGuideStepBox">
          {guideMessage && (
            <BlueAlertBox
              background="icyRed"
              title="주요 안내"
              contents={
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(guideMessage),
                  }}
                />
              }
            />
          )}
          {interlockOpenYn === 'Y' && (
            <BlueAlertBox
              title="2차 인증 안내 문자가 왔어요."
              contents={
                <div>
                  데이터 연동 요청을 위해 2차 인증을 진행해야 하는 경우가
                  발생해요. <br />
                  추가 2차 인증이 필요한 경우, 2차 인증 요청 문자가 발송 될
                  예정이며 안내에 따라 2차 인증을 진행해 주세요.
                </div>
              }
              titleJustifyContent="center"
              background="contentBox"
            />
          )}
          {hasOtherMallAccount === 'Y' && (
            <WideButton onClick={onClickAddMallAccountBtn} />
          )}
          <button
            type="button"
            onClick={() => {
              navigate(ROUTE_PATH.mypage.dataLinkageManage);
            }}
          >
            데이터 연동 관리화면 가기
          </button>
        </div>
      </div>
    </MainWrapper>
  );
};

export default CompletionGuideStep;
